import { render, staticRenderFns } from "./RemediationItem.vue?vue&type=template&id=70b5eb6f&scoped=true"
import script from "./RemediationItem.vue?vue&type=script&lang=js"
export * from "./RemediationItem.vue?vue&type=script&lang=js"
import style0 from "./RemediationItem.vue?vue&type=style&index=0&id=70b5eb6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b5eb6f",
  null
  
)

export default component.exports